module.exports = __webpack_public_path__ + "static/img/LxwlzjscL.c8b8944d.png";